import { Component, OnInit, ViewChild } from "@angular/core";
import { ApiService } from "../../../services/api.service";
import { CUSTOMER_TYPES } from "../../../services/constant";
import { Router } from "@angular/router";
import { CustomerDetailComponent } from "../customer-detail/customer-detail.component";
import { HttpParams } from "@angular/common/http";
import { finalize } from "rxjs/operators";

@Component({
  selector: "app-customer-list",
  templateUrl: "./customer-list.component.html",
  styleUrls: ["./customer-list.component.scss"],
})
export class CustomerListComponent implements OnInit {
  totalItems: number;
  currentPage = 1;
  itemsPerPage = 40;

  searchName;
  searchTaxID;
  searchBranchCode;
  searchBranchName;

  searchingName: boolean = false;
  searchingTaxID: boolean = false;
  searchingBranchCode: boolean = false;
  searchingBranchName: boolean = false;
  loading = false;

  list: any[] = [];
  customerTypes = CUSTOMER_TYPES;
  buyerNameList: any[];
  buyerBranchCodeList: any[];
  buyerBranchNameList: any[];
  buyerTaxIDList: any[];

  selectedCustomerType = this.customerTypes[0];

  @ViewChild("detailModal") detailModal: CustomerDetailComponent;

  constructor(private apiService: ApiService, private router: Router) {}

  ngOnInit() {
    this.initData();
    this.search();
  }

  initData() {
    this.apiService.getBuyerBranch().subscribe((buyerList: any) => {
      this.buyerNameList = buyerList
        .map((obj) => obj.name)
        .filter((item) => item)
        .filter((item, index, array) => {
          return array.indexOf(item) === index;
        });
      this.buyerBranchCodeList = buyerList
        .map((obj) => obj.branch_code)
        .filter((item) => item)
        .filter((item, index, array) => {
          return array.indexOf(item) === index;
        });
      this.buyerBranchNameList = buyerList
        .map((obj) => obj.branch_name)
        .filter((item) => item)
        .filter((item, index, array) => {
          return array.indexOf(item) === index;
        });
      this.buyerTaxIDList = buyerList
        .map((obj) => obj.tax_id)
        .filter((item) => item)
        .filter((item, index, array) => {
          return array.indexOf(item) === index;
        });
    });
  }

  search(resetPage: boolean = true) {
    if (resetPage) {
      this.currentPage = 1;
    }

    let params = new HttpParams()
      .set("page", this.currentPage.toString())
      .set("page_size", this.itemsPerPage.toString())
      .set('required_pagination', 'true');

    if (this.searchName) {
      params = params.append("name", this.searchName);
    }

    if (this.searchTaxID) {
      params = params.append("tax_id", this.searchTaxID);
    }

    if (this.searchBranchCode) {
      params = params.append("branch_code", this.searchBranchCode);
    }

    if (this.searchBranchName) {
      params = params.append("branch_name", this.searchBranchName);
    }

    this.loading = true;
    this.apiService
      .getBuyerBranch(params)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        (response) => {
          this.list = response.results;
          this.totalItems = response.count;
        },
        (error) => {
          console.error(error);
        }
      );
  }

  clearSearch() {
    this.searchName = null;
    this.searchTaxID = null;
    this.searchBranchCode = null;
    this.searchBranchName = null;
    this.search();
  }

  pageChanged() {
    this.search(false);
  }

  optionChanged() {
    this.currentPage = 1;
    this.search();
  }

  openModal(index) {
    this.detailModal.open(this, this.selectedCustomerType, this.list[index]);
  }

  issue(index) {
    const id = this.list[index].id;
    this.router.navigate(["document", "issue", { buyer_branch: id }]);
  }

  reloadDropdown() {
    this.initData();
    this.search();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-list/customer-list.component.ts